<div class="widget-data">
  <div class="container">
    <h2>{{ "Financial-Statements" | translate }}</h2>
    <button (click)="showGlobalError()">
      {{ "annual-financial-statements-2024" | translate }}
      <img
        loading="lazy"
        src="/assets/images/financial-statements/right-arrow.svg"
        alt="official building"
      />
    </button>
    <button (click)="showGlobalError()">
      {{ "second-quarter-financial-statements-2024" | translate }}
      <img
        loading="lazy"
        src="/assets/images/financial-statements/right-arrow.svg"
        alt="official building"
      />
    </button>
    <button (click)="showGlobalError()">
      {{ "third-quarter-financial-statements-2024" | translate }}
      <img
        loading="lazy"
        src="/assets/images/financial-statements/right-arrow.svg"
        alt="official building"
      />
    </button>

    <h2>{{ "board-report" | translate }}</h2>
    <button (click)="showGlobalError()">
      {{ "board-report-2024" | translate }}
      <img
        loading="lazy"
        src="/assets/images/financial-statements/right-arrow.svg"
        alt="official building"
      />
    </button>
  </div>
</div>
